<template>
  <div class="brand-filters">
    <!-- Hotel Name Text Input -->
    <div class="filter-group">
      <label for="hotel-name-input" class="filter-label">{{ $t('Hotel Name') }}</label>
      <input
        id="hotel-name-input"
        v-model="hotelNameInput"
        type="text"
        :placeholder="$t('Search by hotel name')"
        class="hotel-name-input"
        @input="debounceHotelNameUpdate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const emit = defineEmits(['update-hotel-name'])

const route = useRoute()
const hotelNameInput = ref('')
let debounceTimeout: NodeJS.Timeout | null = null

// Initialize from route query
onMounted(() => {
  const hotelNameQuery = route.query.hotel_name as string
  if (hotelNameQuery) {
    hotelNameInput.value = hotelNameQuery
  }
})

// Watch route changes
watch(() => route.query.hotel_name, (newHotelName) => {
  hotelNameInput.value = typeof newHotelName === 'string' ? newHotelName : ''
})

const debounceHotelNameUpdate = () => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout)
  }
  
  debounceTimeout = setTimeout(() => {
    emit('update-hotel-name', hotelNameInput.value.trim())
  }, 500)
}
</script>

<style scoped>
.brand-filters {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-label {
  font-weight: 600;
  font-size: 14px;
  color: var(--black);
  margin-bottom: 4px;
  line-height: 1.2;
}

.hotel-name-input {
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: var(--white);
}

.hotel-name-input:focus {
  outline: none;
  border-color: #1985F9;
  box-shadow: 0 0 0 3px rgba(25, 133, 249, 0.1);
}

.hotel-name-input::placeholder {
  color: #999;
}

.hotel-name-input:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
</style>